module.exports = __webpack_public_path__ + "img/symbol_4.a0abff72.png";